<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { block, addItem, removeItem, updateItem } = useInlineBlockEditor(props.id);

const options = computed<any[]>(() => block.value?.options ?? []);

const addOption = () =>
  addItem("options", { id: crypto.randomUUID(), name: "", value: 0, description: "" });
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:list" accent="assessment">
    <p class="text-[11.5px] text-muted-foreground">{{ t("hint") }}</p>

    <div
      v-for="(option, index) in options"
      :key="option.id ?? index"
      class="flex items-center gap-2"
    >
      <Input
        :model-value="option.name"
        class="h-8 flex-1 rounded-sm bg-muted text-[13px]"
        :placeholder="t('optionNamePlaceholder')"
        @update:model-value="(v) => updateItem('options', index, { name: v })"
      />
      <Input
        :model-value="option.value"
        type="number"
        class="h-8 w-16 rounded-sm bg-muted text-center text-[13px]"
        @update:model-value="(v) => updateItem('options', index, { value: Number(v) })"
      />
      <Button
        variant="ghost"
        size="icon"
        class="size-8 shrink-0 text-destructive"
        @click="removeItem('options', index)"
      >
        <Icon mode="svg" size="16" name="lucide:x" />
      </Button>
    </div>

    <Button variant="outline" size="sm" class="self-start rounded-sm text-[13px]" @click="addOption">
      <Icon mode="svg" size="16" name="lucide:plus" class="mr-1.5" />
      {{ t("addOption") }}
    </Button>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Options"
  hint: "Each option's value contributes to scoring."
  optionNamePlaceholder: "Option label"
  addOption: "Add option"
</i18n>
